import clsx from 'clsx';
import {useState} from 'react';
import type {PartialDeep} from 'type-fest';
import {ProductTfr} from '~/lib/types/tfr';
import {RichTextRenderer} from '@novatize-mattheri/shopify-richtext-renderer';

interface Props {
  product: PartialDeep<ProductTfr>;
}

export function ProductDescriptionTab({product}: Props) {
  const TAB_DESCRIPTION = 'TAB_DESCRIPTION';
  const TAB_HOWITWORKS = 'TAB_HOWITWORKS';
  const [tab, setTab] = useState<string>(TAB_DESCRIPTION);

  const renderProductDescription = () => {
    const description = product.descriptionHtml
      ?.split('<hr class="dashed" data-mce-fragment="1">\n')
      .at(0);

    if (!description) {
      return <></>;
    }

    return (
      <div
        className='text-sm prose max-w-full text-acai-900'
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    );
  };

  const renderHowItWorks = () => {
    if (!product.how_it_works?.value) return <div className='text-sm'>No data available for this.</div>;
    return (
      <div className='prose max-w-full'>
        <RichTextRenderer
          data={product.how_it_works.value}
          h1={{className: 'text-4xl'}}
          h2={{className: 'text-3xl'}}
          h3={{className: 'text-2xl'}}
          h4={{className: 'text-xl'}}
          h5={{className: 'text-xl'}}
          h6={{className: 'text-lg'}}
          paragraph={{className: 'text-sm'}}
        />
      </div>
    );
  };

  return (
    <div className='mt-2'>
      <div className='flex justify-between gap-[10px]'>
        <button
          type='button'
          className={clsx(
            'text-sm font-medium flex-1 rounded-tl-[15px] rounded-tr-[15px] pb-[7px] pt-[11px] text-center transition-all',
            tab == TAB_DESCRIPTION
              ? 'bg-[#E9E3DC] text-acai-900'
              : 'bg-acai-900 text-[#E9E3DC]',
          )}
          onClick={() => setTab(TAB_DESCRIPTION)}
        >
          Description
        </button>
        <button
          type='button'
          className={clsx(
            'text-sm font-medium flex-1 rounded-tl-[15px] rounded-tr-[15px] pb-[7px] pt-[11px] text-center transition-all',
            tab == TAB_HOWITWORKS
              ? 'bg-[#E9E3DC] text-acai-900'
              : 'bg-acai-900 text-[#E9E3DC]',
          )}
          onClick={() => setTab(TAB_HOWITWORKS)}
        >
          More
        </button>
      </div>
      <div className='break-words rounded-bl-[12px] rounded-br-[12px] bg-[#E9E3DC] px-[20px] pb-[22px] pt-[14px] text-acai-900 text-justify'>
        {tab == TAB_DESCRIPTION
          ? renderProductDescription()
          : renderHowItWorks()}
      </div>
    </div>
  );
}
